import { TranslateService } from 'Public_old/src/app/Common/Services/translate.service';
import { environment } from './../../environments/environment';
import { HttpHeaders, HttpParams, HttpResponse, HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SpaEventService } from '../Services/spaEvents.service';
import { PageLoadHandler } from './PageLoadHandler';
import { MessageHandler } from '../Common/Classes/messageHandler';
import { SpaLogger } from '../Common/Classes/Global/spalogger.class';
import { Observable } from 'rxjs';
import { AuthContextService } from '../Services/authContext.service';
import { ApplicationService } from '../Services/application.service';

@Injectable()
export class VisibaApiHttp {
	errorMessage: MessageHandler = null;
	errorMessageTimer: number = null;

	constructor(
		private _pageLoadHandler: PageLoadHandler,
		private _http: HttpClient,
		private _spaEventService: SpaEventService,
		private _spaLogger: SpaLogger,
		private translateService: TranslateService,
		private authContextService: AuthContextService,
		private applicationService: ApplicationService,
	) {}

	get(url: string, showGeneralApiErrorMessage = true, options?: HttpClientOptions): Observable<ApiResponse<any>> {
		return this.getTyped<any>(url, showGeneralApiErrorMessage, options);
	}

	getTyped<T>(
		url: string,
		showGeneralApiErrorMessage = true,
		options?: HttpClientOptions,
		emitLoading: boolean | number = true,
	): Observable<ApiResponse<T>> {
		return Observable.create((observer) => {
			// pass obs
			const request = this._pageLoadHandler.pending(showGeneralApiErrorMessage ? emitLoading : false);

			this._http.get<BackendApiResponse<T>>(environment.api.uri + url, this.getDefaultOptions(options)).subscribe(
				(res) => {
					this.handleSuccess(res, observer, request);
				},
				(err) => {
					this.handleError(err, observer, showGeneralApiErrorMessage, request);
				},
				() => {
					observer.complete();

					if (request !== false) {
						this._pageLoadHandler.resolve(request);
					}
				},
			);
		});
	}

	post(url: string, body: any, showGeneralApiErrorMessage = true, options?: HttpClientOptions): Observable<ApiResponse<any>> {
		return this.postTyped<any>(url, body, showGeneralApiErrorMessage, options);
	}
	postTyped<T>(
		url: string,
		body: any,
		showGeneralApiErrorMessage = true,
		options?: HttpClientOptions,
		emitLoading: boolean | number = true,
	): Observable<ApiResponse<T>> {
		return Observable.create((observer) => {
			const request = this._pageLoadHandler.pending(showGeneralApiErrorMessage ? emitLoading : false);

			this._http.post<BackendApiResponse<T>>(environment.api.uri + url, body, this.getDefaultOptions(options)).subscribe(
				(res) => {
					this.handleSuccess(res, observer, request);
				},
				(err) => {
					this.handleError(err, observer, showGeneralApiErrorMessage, request);
				},
				() => {
					observer.complete();

					if (request !== false) {
						this._pageLoadHandler.resolve(request);
					}
				},
			);
		});
	}

	put(url: string, body: any, showGeneralApiErrorMessage = true, options?: HttpClientOptions): Observable<ApiResponse<any>> {
		return this.putTyped<any>(url, body, showGeneralApiErrorMessage, options);
	}
	putTyped<T>(
		url: string,
		body: any,
		showGeneralApiErrorMessage = true,
		options?: HttpClientOptions,
		emitLoading: boolean | number = true,
	): Observable<ApiResponse<T>> {
		return Observable.create((observer) => {
			const request = this._pageLoadHandler.pending(showGeneralApiErrorMessage ? emitLoading : false);

			this._http
				.put<BackendApiResponse<T>>(environment.api.uri + url, JSON.stringify(body), this.getDefaultOptions(options))
				.subscribe(
					(res) => {
						this.handleSuccess(res, observer, request);
					},
					(err) => {
						this.handleError(err, observer, showGeneralApiErrorMessage, request);
					},
					() => {
						observer.complete();

						if (request !== false) {
							this._pageLoadHandler.resolve(request);
						}
					},
				);
		});
	}

	delete(url: string, showGeneralApiErrorMessage = true, options?: HttpClientOptions): Observable<ApiResponse<any>> {
		return this.deleteTyped<any>(url, showGeneralApiErrorMessage, options);
	}
	deleteTyped<T>(
		url: string,
		showGeneralApiErrorMessage = true,
		options?: HttpClientOptions,
		emitLoading: boolean | number = true,
	): Observable<ApiResponse<T>> {
		return Observable.create((observer) => {
			const request = this._pageLoadHandler.pending(showGeneralApiErrorMessage ? emitLoading : false);

			this._http.delete<BackendApiResponse<T>>(environment.api.uri + url, this.getDefaultOptions(options)).subscribe(
				(res) => {
					this.handleSuccess(res, observer, request);
				},
				(err) => {
					this.handleError(err, observer, showGeneralApiErrorMessage, request);
				},
				() => {
					observer.complete();

					if (request !== false) {
						this._pageLoadHandler.resolve(request);
					}
				},
			);
		});
	}

	postFormData(
		url: string,
		params: any,
		files: FileList,
		sendProgress = false,
		showGeneralApiErrorMessage = true,
	): Observable<ApiResponse<any>> | Observable<number> {
		return Observable.create((observer) => {
			const formData = new FormData();
			const xhr = new XMLHttpRequest();

			for (let i = 0; i < files.length; i++) formData.append('uploads[]', files[i], files[i].name);

			for (const k in params) formData.append(k, params[k].toString());

			xhr.onreadystatechange = () => {
				if (xhr.readyState === 4) {
					let response = xhr.response;
					if (response == null || response === '') response = { Successful: xhr.status === 200, ErrorCode: null };
					else response = JSON.parse(response);

					if (xhr.status === 200) {
						const request = this._pageLoadHandler.pending(showGeneralApiErrorMessage);

						this.handleSuccess(response, observer, request);
					} else {
						this.handleError(response, observer, showGeneralApiErrorMessage, false);
					}
				}
			};

			xhr.withCredentials = true;
			xhr.upload.onprogress = (event) => {
				const progress = Math.round((event.loaded / event.total) * 100);
				if (sendProgress) observer.next(progress);
			};

			xhr.open('POST', url, true);

			const serverFileName = xhr.send(formData);
			return serverFileName;
		});
	}

	showGeneralApiErrorMessage(errorCode: string) {
		if (errorCode === null) return;

		if (this.errorMessage === null) {
			errorCode = µ.Env.ActiveDomain.split('.')[0] + errorCode;
			this.errorMessage = new MessageHandler(
				this.translateService.get('Common.Error.UnexpectedErrorTitle').replace('{{errorCode}}', errorCode),
				this.translateService.get('Common.Error.UnexpectedErrorBody').replace('{{errorCode}}', errorCode),
			).asError();
			this.errorMessage.inform(this.translateService.get('Common.Button.OK')).subscribe(
				(yes) => {
					this.errorMessage = null;
					clearTimeout(this.errorMessageTimer);
				},
				(no) => {
					this.errorMessage = null;
					clearTimeout(this.errorMessageTimer);
				},
			);
			// this.errorMessageTimer = window.setTimeout(() => {
			//    this.errorMessage.destroy();
			//    this.errorMessage = null;
			// }, 30000);
		}
	}

	private handleSuccess(response: HttpResponse<BackendApiResponse<any>>, observer, request: { id: string; timeOut: number } | false) {
		if (request !== false) {
			this._pageLoadHandler.resolve(request);
		}

		if (response.headers) this.checkBackendVersion(response.headers.get('X-App-WebVersion'));

		const res = new ApiResponse<any>(response);
		if (res.sucessful) observer.next(res);
		else observer.error(res);

		observer.complete();
	}

	private handleError(
		response: HttpResponse<BackendApiResponse<any>>,
		observer,
		showGeneralApiErrorMessage,
		request: { id: string; timeOut: number } | false,
	) {
		if (request !== false) {
			this._pageLoadHandler.resolve(request);
		}

		if (response.headers) this.checkBackendVersion(response.headers.get('X-App-WebVersion'));

		if (
			showGeneralApiErrorMessage &&
			(typeof response.status === 'undefined' ||
				(response.status !== 400 && response.status !== 401 && response.status !== 403 && response.status !== 404)) &&
			typeof response.headers !== 'undefined'
		) {
			this.showGeneralApiErrorMessage(response.headers.get('X-App-LogId'));
		}

		if (response.status === 401) {
			this._spaEventService.onSignInRequired.emit({
				target: location.pathname,
				reason: this.translateService.get(
					'Common.Error.Phrase.401SignInRequired' + (this.authContextService.patientIdentity === null ? '' : '_HasIdentity'),
				),
			});
		}

		observer.error(new ApiResponse<any>(response));
	}

	private checkBackendVersion(version: string) {
		if (version === null || this.errorMessage !== null) return;

		if (this.applicationService.webVersion !== version) {
			this.errorMessage = new MessageHandler(
				this.translateService.get('Common.Error.Title.BackendVersionIsOutdated'),
				this.translateService.get('Common.Error.Phrase.BackendVersionIsOutdated'),
			).asWarning();
			this.errorMessage
				.confirm(this.translateService.get('Common.Button.OK'), this.translateService.get('Common.Button.Reload'))
				.subscribe(
					(yes) => {
						this.errorMessage = null;
					},
					(no) => {
						this.errorMessage = null;
						location.reload();
					},
				);
		}
	}

	private getDefaultOptions(overrideOptions?: HttpClientOptions) {
		const defaultOptions: HttpClientOptionsBase = { observe: 'response', responseType: 'json' };
		if (!overrideOptions) return defaultOptions;

		const mergedOptions: HttpClientOptionsBase = Object.assign(defaultOptions, overrideOptions);

		return mergedOptions;
	}
}

export class ApiResponse<T> {
	data: T;
	statusCode: number;
	errorCode: string;
	errorMessage: string;
	sucessful: boolean;
	response: HttpResponse<BackendApiResponse<T>> | Partial<HttpErrorResponse>;

	constructor(response: HttpResponse<BackendApiResponse<T>> | Partial<HttpErrorResponse>) {
		if (response.status) {
			this.statusCode = response.status;
			if (
				response.status === 500 ||
				response.status === 404 ||
				response.headers.get('content-type') === null ||
				response.headers.get('content-type').indexOf('json') === -1
			) {
				this.sucessful = false;
				this.response = response;
				if (typeof response['error'] !== 'undefined') {
					const errorAssHttpErrorResponse: HttpErrorResponse = response as HttpErrorResponse;
					if (errorAssHttpErrorResponse.error.ErrorMessage) this.errorMessage = errorAssHttpErrorResponse.error.ErrorMessage;
					if (errorAssHttpErrorResponse.error.ErrorCode) this.errorCode = errorAssHttpErrorResponse.error.ErrorCode;
				}
			} else if ((response as any)._body !== '') {
				const parsed = response.ok
					? (response as HttpResponse<BackendApiResponse<any>>).body
					: (response as HttpErrorResponse).error;

				this.sucessful = parsed.Successful;
				this.errorCode = parsed.ErrorCode;
				this.errorMessage = parsed.ErrorMessage;
				this.data = parsed.Data;
			}
		} else {
			this.sucessful = (response as any).Successful;
			this.errorCode = (response as any).ErrorCode;
		}
	}
}

export interface HttpClientOptions {
	headers?:
		| HttpHeaders
		| {
				[header: string]: string | string[];
		  };
	params?:
		| HttpParams
		| {
				[param: string]: string | string[];
		  };
	reportProgress?: boolean;
}

export interface HttpClientOptionsBase {
	headers?:
		| HttpHeaders
		| {
				[header: string]: string | string[];
		  };
	observe: 'response';
	params?:
		| HttpParams
		| {
				[param: string]: string | string[];
		  };
	reportProgress?: boolean;
	responseType?: 'arraybuffer' | 'blob' | 'json' | 'text' | any;
	withCredentials?: boolean;
}

export class BackendApiResponse<T> {
	Data: T | null = null;
	Successful: boolean = false;
	ErrorCode: string = '';
	ErrorMessage: string = '';
}
